var _ellipse, _path, _path2, _circle, _circle2, _path3, _path4, _path5, _ellipse2, _path6, _path7, _circle3, _path8, _path9, _circle4, _circle5, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _circle6;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNoResponse(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 109,
    height: 110,
    viewBox: "0 0 109 110",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.68,
    cx: 69.3562,
    cy: 105.3,
    rx: 38.9051,
    ry: 4.69994,
    fill: "#E3E8EF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M57.7178 60.1503L66.9468 69.3975L74.0376 62.5656L63.1989 52.2455L57.7178 60.1503Z",
    fill: "#CDD5DF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M66.7128 70.2179L62.1182 95.2086H79.7655L74.96 69.3975L66.7128 70.2179ZM68.9984 76.2747H72.9581L75.8396 91.5191H66.1844L68.9984 76.2747Z",
    fill: "#99A4B3"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 70.9635,
    cy: 66.5783,
    r: 6.94783,
    fill: "#CDD5DF"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 70.9639,
    cy: 66.5783,
    r: 3.87996,
    fill: "#99A4B3"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M57.6992 96.1878C57.6992 95.0341 58.6344 94.0989 59.7881 94.0989H82.1385C83.2921 94.0989 84.2273 95.0341 84.2273 96.1878V102.4H57.6992V96.1878Z",
    fill: "#CDD5DF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M68.1553 77.1583L68.7925 76.3307L75.3381 81.3707L68.1281 85.0658L76.5285 90.4748L75.9631 91.353L66.0391 84.9632L73.3952 81.193L68.1553 77.1583Z",
    fill: "#99A4B3"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M63.7458 18.1125C63.177 17.3874 62.1092 17.3352 61.4559 17.9852L22.3025 56.9341C21.6847 57.5486 21.6888 58.5471 22.3349 59.1317C23.3342 60.0356 24.8106 61.2932 26.0566 62.0387C34.8813 67.3181 51.187 70.3572 62.6728 58.05C74.1023 45.8031 72.1776 31.9489 66.9561 22.675C66.1713 21.281 64.7371 19.3764 63.7458 18.1125Z",
    fill: "#E3E8EF"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 42.4461,
    cy: 44.3939,
    rx: 21.2655,
    ry: 22.2503,
    fill: "#F1F5F9"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M52.4668 102.026C52.4668 101.439 52.9432 100.968 53.5295 100.981C56.683 101.051 66.0707 101.252 70.9412 101.252C75.8215 101.252 85.3919 101.051 88.5804 100.98C89.1665 100.967 89.6422 101.439 89.6422 102.025V105.013C89.6422 105.279 89.4475 105.502 89.1829 105.529C87.2973 105.72 79.829 106.418 70.9412 106.418C62.0695 106.418 54.7802 105.723 52.9245 105.53C52.6606 105.502 52.4668 105.28 52.4668 105.014L52.4668 102.026Z",
    fill: "#99A4B3"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M74.9248 94.0989C74.9248 94.0989 76.0373 94.2302 76.0373 95.4718C76.0373 96.7134 76.0373 100.426 76.0373 101.236C79.2577 101.169 80.9128 101.138 80.9128 101.138C80.9128 101.138 81.9849 101.073 81.9849 102.186C81.9849 103.298 81.9849 106.106 81.9849 106.106C81.9849 106.106 84.5046 105.969 86.1673 105.836C87.318 105.744 88.5397 105.609 89.1831 105.534C89.4451 105.504 89.6413 105.282 89.6413 105.018V102.024C89.6413 101.438 89.1598 100.967 88.5743 100.98L84.2274 101.073V96.1878C84.2274 95.0341 83.2922 94.0989 82.1385 94.0989H74.9248Z",
    fill: "#6A7585"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 32.1646,
    cy: 27.7787,
    r: 2.61672,
    fill: "#E3E8EF"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M31.8061 19.2943C29.5977 19.386 27.4162 20.2748 25.7301 21.961C24.0101 23.6809 23.1197 25.9163 23.0589 28.1698",
    stroke: "#99A4B3",
    strokeWidth: 1.56665,
    strokeLinecap: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M32.161 13.1327C31.8984 13.1331 31.6358 13.1403 31.3735 13.1542C27.737 13.3467 24.1562 14.8319 21.3785 17.6096C18.6736 20.3145 17.1944 23.7808 16.9409 27.3186C16.9184 27.6319 16.9056 27.9457 16.9024 28.2596",
    stroke: "#99A4B3",
    strokeWidth: 1.56665,
    strokeLinecap: "round"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 3.08825,
    cy: 50.5812,
    r: 2.34997,
    fill: "#CDD5DF",
    stroke: "#CDD5DF",
    strokeWidth: 1.30554
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 91.8313,
    cy: 80.3411,
    r: 1.48661,
    fill: "#CDD5DF",
    stroke: "#CDD5DF",
    strokeWidth: 0.84949
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M51.0902 0V7.13572V0Z",
    fill: "#CDD5DF"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M51.0902 0V7.13572",
    stroke: "#CDD5DF",
    strokeWidth: 1.56665
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M47.5225 3.56786H54.6582H47.5225Z",
    fill: "#CDD5DF"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M47.5225 3.56786H54.6582",
    stroke: "#CDD5DF",
    strokeWidth: 1.56665
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35.1343 79.3768V88.0205V79.3768Z",
    fill: "#CDD5DF"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M35.1343 79.3768V88.0205",
    stroke: "#CDD5DF",
    strokeWidth: 1.30554
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.8125 83.6986H39.4562H30.8125Z",
    fill: "#CDD5DF"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M30.8125 83.6986H39.4562",
    stroke: "#CDD5DF",
    strokeWidth: 1.30554
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 84.3392,
    cy: 47.7827,
    r: 2.34997,
    fill: "#CDD5DF"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoResponse);
export default __webpack_public_path__ + "static/media/no-response.f1fa9e717a9ba387a2d346694e19cff2.svg";
export { ForwardRef as ReactComponent };